const LoaderServiceFactory = ($rootScope) => {
  'ngInject';

  let numCalls = 0;

  const service = {
    addCall: () => {
      numCalls = numCalls + 1;
      if (numCalls === 1) {
        $rootScope.loading = true; // eslint-disable-line
      }
    },
    removeCall: () => {
      if (numCalls > 0) {
        numCalls = numCalls - 1;
      }

      if (numCalls === 0) {
        $rootScope.loading = false; // eslint-disable-line
      }
    },
    abortLoading: () => {
      numCalls = 0;
      $rootScope.loading = false; // eslint-disable-line
    },
    forceLoading: () => {
      $rootScope.loading = true; // eslint-disable-line
    }
  };

  return service;
};

export default LoaderServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/loader.factory.js
 **/